var Actions;
(function (Actions) {
    Actions["GET_BUDGET_CATALOG_LIST"] = "getBudgetCatalogList";
    Actions["GET_BUDGET_CATALOG_LIST_ID_DESC"] = "getBudgetCatalogListIdDesc";
    Actions["CREATE_BUDGET_CATALOG_LIST"] = "createBudgetCatalogList";
    Actions["UPDATE_BUDGET_CATALOG_LIST"] = "updateBudgetCatalogList";
    Actions["GET_BUDGET_CATALOG_LIST_FILTER"] = "getBudgetCatalogListFilter";
    Actions["UPDATE_BUDGET_CATALOG_SIZE"] = "updateBudgetCatalogSize";
    Actions["UPDATE_SELECTED_BUDGET_CATALOG_BUDGETITEMDESC"] = "updateSelectedBudgetCatalogBudgetItemDesc";
    Actions["UPDATE_SELECTED_BUDGET_CATALOG_SUBMISSIONIYEAR"] = "updateSelectedBudgetCatalogSubmissionYear";
    Actions["RESET_BUDGET_CATALOG_FILTER"] = "resetBudgetCatalogFilter";
    Actions["DOWNLOAD_BUDGET_CATALOG"] = "downloadBudgetCatalog";
    Actions["GET_BUDGET_CATALOG_DATA"] = "getBudgetCatalogData";
    Actions["UPDATE_BUDGET_CATALOG_DESC"] = "updateBudgetCatalogDesc";
    Actions["UPDATE_BUDGET_CATALOG_YEAR"] = "updateBudgetCatalogYear";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_BUDGET_CATALOG_LOAD"] = "setBudgetCatalogWasFirstLoad";
    Mutations["SET_BUDGET_CATALOG_LOADING"] = "setBudgetCatalogLoading";
    Mutations["SET_BUDGET_CATALOG_HANDLE_PAGE"] = "setBudgetCatalogHandlePage";
    Mutations["SET_BUDGET_CATALOG_LIST"] = "setBudgetCatalogList";
    Mutations["SET_BUDGET_CATALOG_LIST_BUDGETITEMID"] = "setBudgetCatalogListBudgetItemID";
    Mutations["SET_BUDGET_CATALOG_LIST_BUDGETITEMDESC"] = "setBudgetCatalogListBudgetItemDesc";
    Mutations["SET_BUDGET_CATALOG_LIST_ASSETNUMBER"] = "setBudgetCatalogListBudgetAssetNumber";
    Mutations["SET_BUDGET_CATALOG_LIST_ASSETSUBNUMBER"] = "setBudgetCatalogListBudgetAssetSubNumber";
    Mutations["SET_BUDGET_CATALOG_LIST_ASSETDESC1"] = "setBudgetCatalogListBudgetAssetDesc1";
    Mutations["SET_BUDGET_CATALOG_LIST_SUBMISSIONYEAR"] = "setBudgetCatalogListBudgetSubmissionYear";
    Mutations["SET_BUDGET_CATALOG_LIST_PROFITCENTER"] = "setBudgetCatalogListBudgetProfitCenter";
    Mutations["SET_BUDGET_CATALOG_PAGE"] = "setBudgetCatalogPage";
    Mutations["SET_BUDGET_CATALOG_LOAD_PAGE"] = "setBudgetCatalogLoadPage";
    Mutations["SET_BUDGET_CATALOG_STATUS"] = "setBudgetCatalogStatus";
    Mutations["SET_BUDGET_CATALOG_SIZE"] = "setBudgetCatalogSize";
    Mutations["SET_SELECTED_BUDGET_CATALOG_BUDGETITEMID"] = "setSelectedBudgetCatalogBudgetItemID";
    Mutations["SET_SELECTED_BUDGET_CATALOG_BUDGETITEMDESC"] = "setSelectedBudgetCatalogBudgetItemDesc";
    Mutations["SET_SELECTED_BUDGET_CATALOG_ASSETNUMBER"] = "setSelectedBudgetCatalogBudgetAssetNumber";
    Mutations["SET_SELECTED_BUDGET_CATALOG_ASSETSUBNUMBER"] = "setSelectedBudgetCatalogBudgetAssetSubNumber";
    Mutations["SET_SELECTED_BUDGET_CATALOG_ASSETDESC1"] = "setSelectedBudgetCatalogBudgetAssetDesc1";
    Mutations["SET_SELECTED_BUDGET_CATALOG_SUBMISSIONYEAR"] = "setSelectedBudgetCatalogSubmissionYear";
    Mutations["SET_SELECTED_BUDGET_CATALOG_PROFITCENTER"] = "setSelectedBudgetCatalogProfitCenter";
    Mutations["SET_SELECTED_BUDGET_CATALOG_ADDITIONALINFORMATION"] = "setSelectedBudgetCatalogAdditionalInformation";
    Mutations["SET_BUDGET_CATALOG_RESET"] = "setBudgetCatalogReset";
    Mutations["SET_BUDGET_CATALOG_USEFILTER"] = "setBudgetCatalogUseFilter";
    Mutations["SET_BUDGET_CATALOG_DESC"] = "setBudgetCatalogSelectedDesc";
    Mutations["SET_BUDGET_CATALOG_SEARCH_BY"] = "setBudgetCatalogSelectedSearchBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
